import styled from 'styled-components';
import { inputStyleFactory } from 'components/Form/shared/inputStyleFactory';
import { colors } from 'assets/styled/tokens';
export const Wrapper = styled.div`
  position: relative;
  font-size: ${({ fontSize }) => fontSize};
  font-family: Roboto;
  color: ${colors.carbon};
  width: ${({ width }) => width};
`;
export const SelectBox = styled.div`
  border-radius: ${({ isOpen }) => (isOpen ? '4px 4px 0 0' : '4px')};
  border: 1px solid ${({ error }) => (error ? '#EC6655' : '#e5e5e5')};
  //padding: 8px;
  ${props => inputStyleFactory(props.size)};
  background-color: #fff;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  display: flex;
  align-items: center;
  width: ${({ width }) => width};
  justify-content: space-between;
  box-shadow: ${({ isOpen }) => (isOpen ? '0px 6px 20px 0px #0000004D' : '')};
`;
export const StyledPlaceholder = styled.div`
  font-weight: 400;
  color: ${colors.gray};
`;
export const StyledSelected = styled.div`
  font-weight: ${({ fontWeight }) => fontWeight};
  color: ${({ fontColor }) => (fontColor ? fontColor : colors.carbon)};
`;
export const LeftContent = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  gap: 8px;
`;
export const Dropdown = styled.ul`
  position: absolute;
  width: 100%;
  top: ${({ isSearchable, top }) => (isSearchable ? '0' : top)};
  z-index: 10;
  background-color: white;
  border: 1px solid #e5e5e5;
  max-height: 200px;
  overflow-y: auto;
  border-radius: ${({ isSearchable }) => (isSearchable ? '4px' : '0 0 4px 4px ')};
  margin-top: ${({ isSearchable }) => (isSearchable ? '0' : '4px')};
  box-shadow: 0px 6px 20px -6px #0000004d;
  scrollbar-width: ${({ showScrollbar }) => (showScrollbar ? 'thin' : 'none')};
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  -ms-overflow-style: ${({ showScrollbar }) => (showScrollbar ? 'auto' : 'none')};
  ::-webkit-scrollbar {
    width: 8px;
    display: ${({ showScrollbar }) => (showScrollbar ? 'block' : 'none')};
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }
`;
export const Option = styled.li`
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${({ fontColor }) => (fontColor ? fontColor : colors.carbon)};
  ${props => inputStyleFactory(props.size)};
  &:hover {
    background-color: #eee;
  }
`;
export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
  ${props => inputStyleFactory(props.size)};
  gap: 8px;
`;
export const LeftIcon = styled.div`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none; /* ícone não bloqueia clique no input */
`;

export const RightIcon = styled.div`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-65%);
  cursor: pointer;
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  width: 100%;
  font-size: 14px;
  ::placeholder {
    padding: 20px;
    font-family: Roboto;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.3px;
    color: #7f746a;
  }
`;
export const IconButton = styled.div`
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  color: #888;
`;
